<template>
	<div class="step-row">
		<span class="point" :class="{on:step==1}">1</span>
		<span class="point-text" :class="{on:step==1}">读卡</span>
		<div class="line" :class="{on: step ==1 }"></div>
		
		
		<span class="point" :class="{on:step==3}">3</span>
		<span class="point-text" :class="{on:step==3}">第三步</span>
		<div class="line" :class="{on:step==3}"></div>
		
		<span class="point" :class="{on:step==4}">4</span>
		<span class="point-text":class="{on:step==4}">第四步</span>
		<div class="line":class="{on:step>3}"></div>
		
		<span class="point" :class="{on:step==5}">5</span>
		<span class="point-text" :class="{on:step==5}">第五步</span>
		
		
	</div>
</template>

<script>
	export default {
		name: 'q-step',
		props: {
			step:{
				type:Number,
				default:1
			}
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {

		},
		beforeDestroy() {
			
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	@l:#01A0A0;
	@L:@l;
	.step-row{
		height: 78px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.line{
		width: 16px;
		height: 7px;
		background-color: #D9D9D9;
		margin: 0 7px;
		&.on{
			width: 244px;
		}
	}
	.point{
		width: 48px;
		height: 48px;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		background: #ADADAD;
		border: 3px solid #C9C9C9;
		
		font-size: 29px;color: #fff;
		line-height: 42px;
		text-align: center;
		border-radius: 100px;
		&.on{
			background-color: @L;
			border-color: rgba(0,0,0,0);
		}
	}
	.point-text{
		display: none;
		font-size: 30px;
		color: #01A1A0;
			margin: 0 14px;
			&.on{
				display: block;
			}
	}
</style>
